<template>
  <Modal
    hide-close-button
    :modal-style="{ maxWidth: '400px' }"
    offset-menu
    persistent
    :title="$t('modals.transcript_download_confirm_modal.title')"
  >
    <p>
      {{ $t("modals.transcript_download_confirm_modal.description") }}
    </p>
    <Checkbox
      v-model="thumbnails"
      :label="
        $t('modals.transcript_download_confirm_modal.toggle_thumbnails_label')
      "
      new-design
    />
    <template #buttons>
      <BaseButton
        color="secondary"
        :label="$t('global.cancel')"
        new-design
        @click="cancel"
      />
      <BaseButton
        color="danger"
        :label="$t('global.download')"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "TranscriptDownloadConfirmModal",
  components: {
    Modal,
    BaseButton,
  },
  emits: ["confirm"],
  data() {
    return {
      thumbnails: false,
    };
  },
  methods: {
    cancel() {
      this.$modals.close("TranscriptDownloadConfirmModal");
    },
    confirm() {
      this.$emit("confirm", this.thumbnails);
      this.$modals.close("TranscriptDownloadConfirmModal");
    },
  },
};
</script>

<style scoped>
.checkbox {
  margin: 0;
}
</style>
